import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import styles from './assets/program-book.module.scss';
import AdminLayout from 'src/components/layout/RoleLayout';
import Plot from 'src/components/graphic';
import { RouteComponentProps } from 'react-router';
import Breadcrumbs from '../../../../../../components/Breadcrumbs';
import { QueryParams } from '../../../../../../types/grid';
import Router from '../../../../../../navigation/router';
import { Link } from 'react-router-dom';
import { routes } from '../../../../../../navigation';
import { groupProgramAnswerForPlotV4 } from '../../../../../../helpers/programBook/helperPlotAnswersV4';
import { Button } from 'react-bootstrap';
import Loader from '../../../../../../components/Loader';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { ProgramBookApi } from '../../../../../../services/end-points';
import sortingService from '../../../../../../services/sorting';
import { useAsyncDebounce } from 'react-table';
import AbaLineChartE from '../../../../../../components/graphic/chart/AbaLineChartE';

export interface StateProps {
    programBooks: any;
    programBook: any;
    programBookAnswers: any;
    inProgressAnswers: any;
}

export interface DispatchProps {
    getProgramBooks: (param: QueryParams) => void;
    getProgramBookEntity: (id: string, isHidden: string) => void;
    getProgramBookAnswers: (param: QueryParams) => void;
}

interface RouteParams {
    id: string;
}

export interface OwnProps extends RouteComponentProps<RouteParams> {}
export interface Props extends StateProps, DispatchProps, OwnProps {}

const MemoPlot = React.memo(Plot);
const MemoAbaLineChartE = React.memo(AbaLineChartE);

const ProgramBookGraphV4Screen: React.FunctionComponent<Props> = (props: Props) => {
    const [isHidden, setIsHidden] = useState('0');
    const [clickedTarget, setClickedTarget] = useState(0);
    const [requestedTargets, setRequestedTargets] = useState<any[]>([]);

    const [dataGrouped, setDataGrouped] = useState<any>([]);
    const [dataCollected, setDataCollected] = useState(0);
    const [isLoad, setIsLoad] = useState(0);
    const [isNewSetOfData, setIsNewSetOfData] = useState(0);
    const [isHideButton, setIsHideButton] = useState<number[]>([]);
    const [isGetAnswers, setIsGetAnswers] = useState(0);
    const listData: any[] = [];
    const [collectedAnswers, setCollectedAnswers] = useState({ data: { list: listData } });

    const [loadingTargetId, setLoadingTargetId] = useState<number | null>(null);

    const [groupedByTarget, setGroupedByTarget] = useState<Record<number, any>>({});

    const [dataCollectedAnswers, setDataCollectedAnswers] = useState<any[]>([]);
    const [answersByTargetId, setAnswersByTargetId] = useState<Record<number, any[]>>({});

    const [sectionFirst, setSectionFirst] = useState(false);
    const [sectionSecond, setSectionSecond] = useState(false);

    const [sectionNumber, setSectionNumber] = useState(1);

    const [globalFilters, setGlobalFilters] = React.useState({
        dateFrom: moment().add(-100, 'years').format('YYYY-MM-DD'),
        dateTo: moment().format('YYYY-MM-DD'),
    });

    const onChange = useAsyncDebounce((change) => {
        setGlobalFilters({ ...globalFilters, [change.id]: change.value });
        setSectionFirst(false);
        setSectionSecond(false);
    }, 200);

    const {
        match: {
            params: { id },
        },
        programBooks,
        getProgramBooks,
        programBookAnswers,
        getProgramBookAnswers,
        programBook,
        getProgramBookEntity,
        inProgressAnswers,
    } = props;

    useEffect(() => {
        if (!programBook) {
            getProgramBookEntity(id, '1');
        }
    }, []);

    useEffect(() => {
        getProgramBookEntity(id, '1');
    }, [dataCollected, sectionNumber]);

    const dispatch = useDispatch();

    let inProgress = false;

    useEffect(() => {
        if (
            (sectionNumber == 1 && sectionFirst == false) ||
            (sectionNumber == 2 && sectionSecond == false) ||
            clickedTarget !== 0
        ) {
            if (programBook) {
                const { programMainCategories, ...res } = programBook;
                if (programMainCategories) {
                    Object.values(programMainCategories).map(async (section: any) => {
                        if (
                            (sectionNumber == 1 && section.title == 'Skill Acquisition') ||
                            (sectionNumber == 2 && section.title == 'Behavior Reduction')
                        ) {
                            section.programCategories = section.programCategories
                                ? !Array.isArray(section.programCategories)
                                    ? Object.values(section.programCategories)
                                    : section.programCategories
                                : [];
                            for (const domain of section.programCategories) {
                                domain.programCategories = domain.programCategories
                                    ? !Array.isArray(domain.programCategories)
                                        ? Object.values(domain.programCategories)
                                        : domain.programCategories
                                    : [];

                                for (const longTerm of domain.programCategories) {
                                    longTerm.programCategories = longTerm.programCategories
                                        ? !Array.isArray(longTerm.programCategories)
                                            ? Object.values(longTerm.programCategories)
                                            : longTerm.programCategories
                                        : [];

                                    const targets: number[] = [];
                                    for (const shortTerm of longTerm.programCategories) {
                                        shortTerm.programTargets = shortTerm.programTargets
                                            ? !Array.isArray(shortTerm.programTargets)
                                                ? Object.values(shortTerm.programTargets)
                                                : shortTerm.programTargets
                                            : [];

                                        for (const target of shortTerm.programTargets) {
                                            if (clickedTarget !== 0 && target.id == clickedTarget) {
                                                if (
                                                    !requestedTargets.find((obj: string | number) => obj === target.id)
                                                ) {
                                                    targets.push(target.id);
                                                    const reTarget: any[] = requestedTargets;
                                                    reTarget.push(target.id);
                                                    setRequestedTargets(reTarget);
                                                    setClickedTarget(0);
                                                }
                                            }
                                        }
                                    }

                                    if (targets.length) {
                                        inProgress = true;
                                        await setIsLoad(1);
                                        setIsGetAnswers(1);
                                        await ProgramBookApi.getProgramBookAnswersForPlot({
                                            ...{
                                                'programBook.id': programBook.id,
                                                dateFrom: globalFilters.dateFrom,
                                                dateTo: globalFilters.dateTo,
                                                programTarget: targets,
                                                'axios-retry': {
                                                    retries: 3,
                                                },
                                            },
                                            order: sortingService.makeOrder({}),
                                            page: 1,
                                            itemsPerPage: 100000,
                                            pagination: 1,
                                        })
                                            .then(async (response2) => {
                                                const ss: any[] = response2.data?.data
                                                    ? JSON.parse(response2.data?.data)
                                                    : [];

                                                setAnswersByTargetId((prev) => {
                                                    const next = { ...prev };

                                                    for (const ans of ss) {
                                                        const tid = ans.programTarget?.id;
                                                        if (!tid) continue;

                                                        next[tid] = [...(next[tid] ?? []), ans];
                                                    }

                                                    return next;
                                                });
                                                setIsNewSetOfData(1);
                                                setIsLoad(0);

                                                setCollectedAnswers((prev) => ({
                                                    data: { list: [...(prev.data.list ?? []), ...ss] },
                                                }));
                                                setLoadingTargetId(null);
                                            })
                                            .catch((e) => {
                                                console.error(e);
                                                setLoadingTargetId(null);
                                            });
                                    } else {
                                        inProgress = true;
                                        setIsGetAnswers(1);
                                        const da: any = dataCollectedAnswers;
                                        setDataCollectedAnswers(da);
                                        setCollectedAnswers({ data: { list: da } });
                                    }
                                }
                            }
                        }
                    });
                    inProgress = false;
                }
                if (sectionNumber === 1) {
                    setSectionFirst(true);
                } else if (sectionNumber === 2) {
                    setSectionSecond(true);
                }
            }
        } else {
            setDataCollected(1);
        }
    }, [programBook, sectionNumber, clickedTarget, globalFilters.dateTo, globalFilters.dateFrom]);

    useEffect(() => {
        if (!programBook) return;

        const { groupedTargets, tree } = groupProgramAnswerForPlotV4(
            programBook,
            answersByTargetId,
            globalFilters,
            isHideButton,
            groupedByTarget,
        );

        setGroupedByTarget(groupedTargets);
        setDataGrouped(tree);

        setDataCollected(1);
        if (!isHideButton.length) {
            setIsLoad(0);
        }
        setIsNewSetOfData(0);
    }, [programBook, answersByTargetId, isNewSetOfData, globalFilters, isHideButton]);

    function renderPhaseInfo(phase: any) {
        return (
            <span className={styles.phaseItem}>
                <b>{phase?.title}:</b>{' '}
                {phase?.startDate ? moment(phase?.startDate, 'YYYY-MM-DD HH:mm:ss').format('ll') : ''}
                {phase?.endDate ? ' - ' + moment(phase?.endDate, 'YYYY-MM-DD HH:mm:ss').format('ll') : ''}
                {'; '}
            </span>
        );
    }

    return (
        <AdminLayout>
            {!programBook || inProgressAnswers ? <Loader /> : null}
            <Breadcrumbs items={[{ name: `Program Book V4`, path: '' }]} />
            <div className={classNames(styles.wrapForm)}>
                <div className={styles.orderInfo}>
                    Student:
                    <Link
                        target="_blank"
                        to={Router.generate(routes.STUDENT_DETAIL, {
                            id: programBook?.student?.id,
                            tab: 'student-info',
                        })}
                    >
                        {programBook?.student?.firstName ? ' ' + programBook?.student?.firstName : ''}
                        {programBook?.student?.lastName ? ' ' + programBook?.student?.lastName : ''}
                    </Link>
                </div>

                <div className={classNames(styles.orderInfo, styles.sectionButton)}>
                    <Button
                        className={classNames(
                            'mr-2',
                            sectionNumber == 1 ? styles.sectionActiveButton : styles.sectionInActiveButton,
                        )}
                        variant="secondary"
                        onClick={() => {
                            setSectionNumber(1);
                            setDataCollected(0);
                            setRequestedTargets([]);
                        }}
                    >
                        Skill Acquisition Section
                    </Button>
                    <Button
                        className={classNames(
                            'mr-2',
                            sectionNumber == 2 ? styles.sectionActiveButton : styles.sectionInActiveButton,
                        )}
                        variant="secondary"
                        onClick={() => {
                            setSectionNumber(2);
                            setDataCollected(0);
                            setRequestedTargets([]);
                        }}
                    >
                        Behavior Reduction Section
                    </Button>
                </div>
                {isHidden == '0' ? (
                    <Button
                        className={classNames('mr-2', styles.seeAllTargetButton)}
                        variant="secondary"
                        onClick={() => {
                            setIsHidden('1');
                        }}
                    >
                        Click here to see active and hidden
                    </Button>
                ) : (
                    <Button
                        className={classNames('mr-2', styles.seeAllTargetButton)}
                        variant="secondary"
                        onClick={() => {
                            setIsHidden('0');
                        }}
                    >
                        Click here to see active only
                    </Button>
                )}

                <div className={styles.plotAnswerContainer}>
                    {dataCollected
                        ? dataGrouped.map((section: any) => {
                              return (sectionNumber == 1 && section.section.title == 'Skill Acquisition') ||
                                  (sectionNumber == 2 && section.section.title == 'Behavior Reduction') ? (
                                  <div
                                      key={'section-' + section.section.id}
                                      data-level="SE"
                                      className={styles.sectionContainer}
                                  >
                                      <h2>{section.section.title}</h2>
                                      <div className={styles.description}>{section.section.description}</div>
                                      <div>
                                          {section.dataDomain.map((domain: any, indexS: number) => (
                                              <div
                                                  key={'domain-' + domain.domain.id}
                                                  data-level="DO"
                                                  className={classNames(
                                                      styles.domainContainer,
                                                      isHidden === '0' && domain.domain.isHidden == true
                                                          ? styles.hiddenTarget
                                                          : {},
                                                  )}
                                              >
                                                  <h3>
                                                      {domain.domain.title}
                                                      {domain.domain.isHidden == true ? <b>(hidden)</b> : ''}
                                                  </h3>
                                                  <div className={styles.description}>{domain.domain.description}</div>
                                                  <div>
                                                      {domain.dataLongTerm.map((longTerm: any, indexD: number) => (
                                                          <div
                                                              key={'long-' + longTerm.longTerm.id}
                                                              data-level="LT"
                                                              className={classNames(
                                                                  styles.longTermContainer,
                                                                  isHidden === '0' && longTerm.longTerm.isHidden == true
                                                                      ? styles.hiddenTarget
                                                                      : {},
                                                              )}
                                                          >
                                                              <h4>
                                                                  {longTerm.longTerm.title}
                                                                  {longTerm.longTerm.isHidden == true ? (
                                                                      <b>(hidden)</b>
                                                                  ) : (
                                                                      ''
                                                                  )}
                                                              </h4>
                                                              <div className={styles.description}>
                                                                  {longTerm.longTerm.description}
                                                              </div>
                                                              <div>
                                                                  {longTerm.dataShortTerm.map(
                                                                      (shortTerm: any, indexL: number) => (
                                                                          <div
                                                                              key={'short-' + shortTerm.shortTerm.id}
                                                                              data-level="ST"
                                                                              className={classNames(
                                                                                  styles.shortTermContainer,
                                                                                  isHidden === '0' &&
                                                                                      shortTerm.shortTerm.isHidden ==
                                                                                          true
                                                                                      ? styles.hiddenTarget
                                                                                      : {},
                                                                              )}
                                                                          >
                                                                              <h5>
                                                                                  {shortTerm.shortTerm.title}
                                                                                  {shortTerm.shortTerm.isHidden ==
                                                                                  true ? (
                                                                                      <b>(hidden)</b>
                                                                                  ) : (
                                                                                      ''
                                                                                  )}
                                                                              </h5>
                                                                              <div className={styles.description}>
                                                                                  {shortTerm.shortTerm.description}
                                                                              </div>
                                                                              <div>
                                                                                  {shortTerm.answers.map(
                                                                                      (
                                                                                          targetAnswers: any,
                                                                                          index: number,
                                                                                      ) => {
                                                                                          const targetId =
                                                                                              targetAnswers.target.id;
                                                                                          const hasAnswers =
                                                                                              targetAnswers.answers
                                                                                                  .length > 0;
                                                                                          const isRequested = isHideButton.includes(
                                                                                              targetId,
                                                                                          );
                                                                                          const isLoadingThisTarget =
                                                                                              loadingTargetId ===
                                                                                              targetId;

                                                                                          return (
                                                                                              <div
                                                                                                  key={
                                                                                                      'target-' +
                                                                                                      targetAnswers
                                                                                                          .target.id
                                                                                                  }
                                                                                                  className={classNames(
                                                                                                      styles.targetContainer,
                                                                                                      isHidden ===
                                                                                                          '0' &&
                                                                                                          targetAnswers
                                                                                                              .target
                                                                                                              .isHidden ==
                                                                                                              true
                                                                                                          ? styles.hiddenTarget
                                                                                                          : {},
                                                                                                  )}
                                                                                              >
                                                                                                  <h6>
                                                                                                      {
                                                                                                          targetAnswers
                                                                                                              .target
                                                                                                              .title
                                                                                                      }
                                                                                                      {targetAnswers
                                                                                                          .target
                                                                                                          .type == 2
                                                                                                          ? ', seconds'
                                                                                                          : ''}
                                                                                                      {targetAnswers
                                                                                                          .target
                                                                                                          .isHidden ==
                                                                                                      true ? (
                                                                                                          <b>
                                                                                                              (hidden)
                                                                                                          </b>
                                                                                                      ) : (
                                                                                                          ''
                                                                                                      )}
                                                                                                  </h6>
                                                                                                  {targetAnswers.target
                                                                                                      .prompt &&
                                                                                                  (targetAnswers.target
                                                                                                      .type == 1 ||
                                                                                                      targetAnswers
                                                                                                          .target
                                                                                                          .type ==
                                                                                                          3) ? (
                                                                                                      <div
                                                                                                          className={
                                                                                                              styles.targetDescription
                                                                                                          }
                                                                                                      >
                                                                                                          Prompt:
                                                                                                          <b>
                                                                                                              {' ' +
                                                                                                                  targetAnswers
                                                                                                                      .target
                                                                                                                      .prompt}
                                                                                                          </b>
                                                                                                      </div>
                                                                                                  ) : null}
                                                                                                  <div
                                                                                                      className={
                                                                                                          styles.targetDescription
                                                                                                      }
                                                                                                  >
                                                                                                      {
                                                                                                          targetAnswers
                                                                                                              .target
                                                                                                              .description
                                                                                                      }
                                                                                                  </div>
                                                                                                  <div
                                                                                                      className={
                                                                                                          styles.phaseItems
                                                                                                      }
                                                                                                  >
                                                                                                      {targetAnswers
                                                                                                          .target
                                                                                                          .isPhased &&
                                                                                                      targetAnswers
                                                                                                          .target
                                                                                                          .programTargetPhases
                                                                                                          .length ? (
                                                                                                          <div>
                                                                                                              <b>
                                                                                                                  Phases:
                                                                                                              </b>
                                                                                                          </div>
                                                                                                      ) : null}
                                                                                                      {targetAnswers
                                                                                                          .target
                                                                                                          .isPhased
                                                                                                          ? targetAnswers.target.programTargetPhases?.map(
                                                                                                                (
                                                                                                                    phase: any,
                                                                                                                ) =>
                                                                                                                    renderPhaseInfo(
                                                                                                                        phase,
                                                                                                                    ),
                                                                                                            )
                                                                                                          : null}
                                                                                                  </div>

                                                                                                  {hasAnswers && (
                                                                                                      <MemoPlot
                                                                                                          data={
                                                                                                              targetAnswers.answers
                                                                                                          }
                                                                                                          target={
                                                                                                              targetAnswers.target
                                                                                                          }
                                                                                                      />
                                                                                                  )}
                                                                                                  {!hasAnswers &&
                                                                                                      isRequested &&
                                                                                                      isLoadingThisTarget && (
                                                                                                          <div
                                                                                                              className={
                                                                                                                  styles.chartLoaderWrapper
                                                                                                              }
                                                                                                          >
                                                                                                              <div
                                                                                                                  className="spinner-border"
                                                                                                                  role="status"
                                                                                                              >
                                                                                                                  <span className="sr-only">
                                                                                                                      Loading...
                                                                                                                  </span>
                                                                                                              </div>
                                                                                                          </div>
                                                                                                      )}

                                                                                                  {!hasAnswers &&
                                                                                                      !isRequested && (
                                                                                                          <Button
                                                                                                              className={classNames(
                                                                                                                  'mr-2',
                                                                                                                  styles.seeAllTargetButton,
                                                                                                              )}
                                                                                                              variant="secondary"
                                                                                                              disabled={
                                                                                                                  isLoadingThisTarget
                                                                                                              }
                                                                                                              onClick={() => {
                                                                                                                  setIsHideButton(
                                                                                                                      (
                                                                                                                          prev: number[],
                                                                                                                      ) =>
                                                                                                                          prev.includes(
                                                                                                                              targetId,
                                                                                                                          )
                                                                                                                              ? prev
                                                                                                                              : [
                                                                                                                                    ...prev,
                                                                                                                                    targetId,
                                                                                                                                ],
                                                                                                                  );
                                                                                                                  setClickedTarget(
                                                                                                                      targetId,
                                                                                                                  );
                                                                                                                  setLoadingTargetId(
                                                                                                                      targetId,
                                                                                                                  );
                                                                                                              }}
                                                                                                          >
                                                                                                              {isLoadingThisTarget
                                                                                                                  ? 'Loading…'
                                                                                                                  : 'See results'}
                                                                                                          </Button>
                                                                                                      )}

                                                                                                  {!hasAnswers &&
                                                                                                      isRequested &&
                                                                                                      !isLoadingThisTarget &&
                                                                                                      !isLoad &&
                                                                                                      targetAnswers.isClickedAnsweredEmpty && (
                                                                                                          <div>
                                                                                                              This
                                                                                                              target has
                                                                                                              no answers
                                                                                                              yet.
                                                                                                          </div>
                                                                                                      )}
                                                                                              </div>
                                                                                          );
                                                                                      },
                                                                                  )}
                                                                              </div>
                                                                          </div>
                                                                      ),
                                                                  )}
                                                              </div>
                                                          </div>
                                                      ))}
                                                  </div>
                                              </div>
                                          ))}
                                      </div>
                                  </div>
                              ) : null;
                          })
                        : null}
                </div>
            </div>
        </AdminLayout>
    );
};

export default ProgramBookGraphV4Screen;
